import { createFileRoute, useCanGoBack } from '@tanstack/react-router';

import { Authentication } from '@/rbac';
import Profile from '@/routes/arc/_sip/profile/-Profile.tsx';

export const Route = createFileRoute('/arc/_sip/profile')({
  component: ProfilePage,
});

function ProfilePage() {
  const callGoback = useCanGoBack();

  return (
    <div className={'fit-col p-2.5'}>
      <Authentication require={['arc:profile']} failMode={'empty'}>
        <Profile
          key={'scheme-page'}
          hasBack={callGoback}
          showEdit={true}
          showSwitch={false}
        />
      </Authentication>
    </div>
  );
}
